import script from "./HowItWorksView.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorksView.vue?vue&type=script&setup=true&lang=js"

import "./HowItWorksView.vue?vue&type=style&index=0&id=1590f561&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1590f561"]])

export default __exports__